import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
import { styleMap } from "lit-html/directives/style-map";
class ChatBotLoading extends LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        const style = {
            "object-fit": "cover",
        };
        return html `
      <div class="absolute h-100 w-100 flex justify-around">
        <img
          class="h-100"
          src="${paths.chatbotLoading}"
          style="${styleMap(style)}"
        />
      </div>
    `;
    }
    renderOld() {
        return html `<div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>`;
    }
}
customElements.define("jh-chat-bot-loading", ChatBotLoading);
//# sourceMappingURL=chatBotLoading.js.map